import * as ACTION_TYPES from './participationActionTypes';

export const participationReducerInitialState = {
	listOfParticipations: {
		hasError: false,
		isFetching: false,
		data: null,
		meta: null,
		error: undefined,
	},
	listOfParticipationsDNI: {
		hasError: false,
		isFetching: false,
		data: null,
		meta: null,
		error: undefined,
	},
	postParticipation: {
		hasError: false,
		isFetching: false,
		data: null,
		error: undefined,
	},
	postStoreParticipationOffline: {
		data: [],
	},
	postStoreParticipationOfflineDNI: {
		data: [],
	},
};

export const participationReducer = (
	state = participationReducerInitialState,
	action
) => {
	switch (action.type) {
		case ACTION_TYPES.LIST_OF_PARTICIPATION_REQUEST: {
			return {
				...state,
				listOfParticipations: {
					hasError: false,
					isFetching: true,
					data: null,
					meta: null,
					error: undefined,
				},
			};
		}
		case ACTION_TYPES.LIST_OF_PARTICIPATION_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				listOfParticipations: {
					...state.listOfParticipations,
					isFetching: false,
					hasError: false,
					error: undefined,
					data: data,
					meta: {
						limit: action.payload.limit,
						page: action.payload.page,
						pages: action.payload.pages,
						count: action.payload.count,
					},
				},
			};
		}

		case ACTION_TYPES.LIST_OF_PARTICIPATION_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				listOfParticipations: {
					...state.listOfParticipations,
					isFetching: false,
					hasError: true,
				},
			};
		}
		case ACTION_TYPES.CLEAR_LIST_OF_PARTICIPATION_PARAMS: {
			return {
				...participationReducerInitialState,
			};
		}
		case ACTION_TYPES.LIST_OF_PARTICIPATION_DNI_REQUEST: {
			return {
				...state,
				listOfParticipationsDNI: {
					hasError: false,
					isFetching: true,
					data: null,
					meta: null,
					error: undefined,
				},
			};
		}
		case ACTION_TYPES.LIST_OF_PARTICIPATION_DNI_REQUEST_SUCCESS: {
			const { data, meta } = action.payload;
			return {
				...state,
				listOfParticipationsDNI: {
					...state.listOfParticipationsDNI,
					isFetching: false,
					hasError: false,
					error: undefined,
					data: data,
					meta: meta,
				},
			};
		}

		case ACTION_TYPES.LIST_OF_PARTICIPATION_DNI_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				listOfParticipationsDNI: {
					...state.listOfParticipationsDNI,
					isFetching: false,
					hasError: true,
				},
			};
		}
		case ACTION_TYPES.CLEAR_LIST_OF_PARTICIPATION_DNI_PARAMS: {
			return {
				...participationReducerInitialState,
			};
		}

		case ACTION_TYPES.POST_PARTICIPATION_REQUEST: {
			return {
				...state,
				isFetching: true,
				hasError: false,
				isLoggedIn: false,
				error: undefined,
			};
		}
		case ACTION_TYPES.POST_PARTICIPATION_REQUEST_SUCCESS: {
			const { data } = action.payload;
			return {
				...state,
				postParticipation: {
					...state.postParticipation,
					isFetching: false,
					hasError: false,
					error: undefined,
					data: data,
				},
			};
		}

		case ACTION_TYPES.POST_PARTICIPATION_REQUEST_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				postParticipation: {
					...state.postParticipation,
					isFetching: false,
					hasError: true,
				},
			};
		}

		case ACTION_TYPES.POST_STORE_PARTICIPATION_OFFLINE: {
			return {
				...state,
				postStoreParticipationOffline: {
					...state.postStoreParticipationOffline,
					data: action.payload,
				},
			};
		}

		case ACTION_TYPES.CLEAR_POST_STORE_PARTICIPATION_OFFLINE: {
			return {
				...state,
				postStoreParticipationOffline: {
					data: [],
				},
			};
		}

		case ACTION_TYPES.POST_STORE_PARTICIPATION_OFFLINE_DNI: {
			return {
				...state,
				postStoreParticipationOfflineDNI: {
					...state.postStoreParticipationOfflineDNI,
					data: action.payload,
				},
			};
		}

		case ACTION_TYPES.CLEAR_POST_STORE_PARTICIPATION_OFFLINE_DNI: {
			return {
				...state,
				postStoreParticipationOfflineDNI: {
					data: [],
				},
			};
		}

		default: {
			return state;
		}
	}
};

export default participationReducer;

export const getParticipationReducer = state => state.participationReducer;

// get
export const getListOfParticipationsData = state =>
	getParticipationReducer(state)?.listOfParticipations?.data;
export const getListOfParticipationsDataMetaData = state =>
	getParticipationReducer(state)?.listOfParticipations?.meta;
export const getListOfParticipationsIsFetching = state =>
	getParticipationReducer(state)?.listOfParticipations?.isFetching;

export const getListOfParticipationsDNIData = state =>
	getParticipationReducer(state)?.listOfParticipationsDNI?.data;
export const getListOfParticipationsDataMetaDNIData = state =>
	getParticipationReducer(state)?.listOfParticipationsDNI?.meta;
export const getListOfParticipationsDNIIsFetching = state =>
	getParticipationReducer(state)?.listOfParticipationsDNI?.isFetching;
// post
export const getPostUsersData = state =>
	getParticipationReducer(state)?.postParticipation?.data;
export const getPostUsersIsFetching = state =>
	getParticipationReducer(state)?.postParticipation?.isFetching;

// OFLINE
export const getParticipationOffline = state =>
	getParticipationReducer(state).postStoreParticipationOffline;

// OFLINE
export const getParticipationOfflineDNI = state =>
	getParticipationReducer(state).postStoreParticipationOfflineDNI;
